import { SESSION_COMPANY } from 'utils/constants'
import { jsonParse, jsonStringify } from 'utils/jsonUtil'

const selectedCompany = jsonParse(localStorage.getItem(SESSION_COMPANY))

const state = selectedCompany
  ? {
    selectedCompany
  }
  : {
    selectedCompany: null
  }

const actions = {
  updateSelectedCompany ({ commit }, company) {
    localStorage.setItem(SESSION_COMPANY, jsonStringify(company || '{}'))
    commit('updateSelectedCompany', company)
  },

  clearSelectedCompany ({ commit }) {
    localStorage.removeItem(SESSION_COMPANY)
    commit('clearSelectedCompany')
  }
}

const mutations = {
  updateSelectedCompany (state, company) {
    state.selectedCompany = company
  },

  clearSelectedCompany (state) {
    state.selectedCompany = null
  }
}

const Company = {
  namespaced: true,
  state,
  actions,
  mutations
}

export default Company
